/**
 * Returns a date in the format yyyy from an RFC3339 formatted string.
 *
 * @param {string} string
 *    RFC3339 formatted string.
 * @param {boolean} offsetTimezone
 *    Whether to shift the date using the local timezone (from UTC).
 *
 * @returns {string}
 *    A yyyy formatted string or 0000 on error.
 */
 export function rfc3339StringToYearString(string, offsetTimezone = false) {
  if (typeof string !== 'string') {
    return '00/00/0000';
  }
  try {
    // Parse it into a date
    let date = new Date(string);
    if (offsetTimezone) {
      // Get our timezone offset.
      const offset = date.getTimezoneOffset();
      // Adjust the date accordingly.
      date = new Date(date.getTime() + (offset*60*1000));
    }
    // Convert to ISO string and grab the date part.
    const dateString = date.toISOString().split('T')[0];
    // 0?
    if (dateString === '1970-01-01') {
      return '0000';
    }
    // Then rearrange to a more human-familiar order.
    // use &#8209; non breaking hyphen?
    return dateString.substring(0,4);
  }
  catch (error) {
    return '0000';
  }
}

/**
 * Returns a date in the format dd/mm/yyyy from an RFC3339 formatted string.
 *
 * @param {string} string
 *    RFC3339 formatted string.
 * @param {boolean} offsetTimezone
 *    Whether to shift the date using the local timezone (from UTC).
 *
 * @returns {string}
 *    A dd/mm/yyyy formatted string or 00/00/0000 on error.
 */
export function rfc3339StringToDateString(string, offsetTimezone = false) {
  if (typeof string !== 'string') {
    return '00/00/0000';
  }
  try {
    // Parse it into a date
    let date = new Date(string);
    if (offsetTimezone) {
      // Get our timezone offset.
      const offset = date.getTimezoneOffset();
      // Adjust the date accordingly.
      date = new Date(date.getTime() + (offset*60*1000));
    }
    // Convert to ISO string and grab the date part.
    const dateString = date.toISOString().split('T')[0];
    // 0?
    if (dateString === '1970-01-01') {
      return '-';
    }
    // Then rearrange to a more human-familiar order.
    // use &#8209; non breaking hyphen?
    return dateString.substring(8,10) + '/' +
          dateString.substring(5,7) + '/' +
          dateString.substring(0,4);
  }
  catch (error) {
    return '00/00/0000';
  }
}

/**
 * Returns a datetime in the format dd/mm/yyyy hh:mm:ss from an RFC3339
 * formatted string.
 *
 * @param {string} string
 *    RFC3339 formatted string.
 * @param {boolean} offsetTimezone
 *    Whether to shift the date using the local timezone (from UTC).
 *
 * @returns {string}
 *    A dd/mm/yyyy hh:mm:ss formatted string or 00/00/0000 00:00:00 on error.
 */
export function rfc3339StringToDateTimeString(string, offsetTimezone = false) {
  if (typeof string !== 'string') {
    return '00/00/0000 00:00:00';
  }
  try {
    // Parse it into a date
    let date = new Date(string);
    if (offsetTimezone) {
      // Get our timezone offset.
      const offset = date.getTimezoneOffset();
      // Adjust the date accordingly.
      date = new Date(date.getTime() + (offset*60*1000));
    }
    // Convert to ISO string and grab the date part.
    const splitString = date.toISOString().split('T');
    const dateString = splitString[0];
    const timeString = splitString[1].split('.')[0];

    // 0?
    if (dateString === '1970-01-01') {
      return '00/00/0000 00:00:00';
    }
    // Then rearrange to a more human-familiar order.
    // use &#8209; non breaking hyphen?
    return dateString.substring(8,10) + '/' +
          dateString.substring(5,7) + '/' +
          dateString.substring(0,4) + ' ' +
          timeString;
  }
  catch (error) {
    return '00/00/0000 00:00:00';
  }
}
